import {
  INICIA_ENQUETES,
  NOVO_ENQUETE,
  INICIO_ENQUETES_SUCESSO,
  SALVA_ENQUETE_LOCAL,
  SALVA_ENQUETE_SUCESSO,
  REMOVE_ENQUETE_LOCAL,
  REMOVE_ENQUETE_SUCESSO,
  LISTA_ENQUETES,
  LISTA_ENQUETES_SUCESSO,
  BUSCA_ENQUETE_EDICAO,
  BUSCA_ENQUETE_EDICAO_SUCESSO,
  ABRE_DASHBOARD_ENQUETE,
  ABRE_DASHBOARD_ENQUETE_SUCESSO,
  FECHA_DASHBOARD_ENQUETE,
  REGISTRA_VOTO_ENQUETE,
  REGISTRA_VOTO_ENQUETE_SUCESSO,
  CANCELA_EDICAO_ENQUETE,
  LIMPAR_ENQUETE,
  ENQUETES_SHOW_MESSAGE,
  SETAR_IMAGEM_ENQUETE,
  ENQUETES_HIDE_MESSAGE,
  ATUALIZA_HORARIO
} from 'constants/ActionTypes';

export const iniciaEnquetes = () => ({ type: INICIA_ENQUETES });

export const novoEnquete = () => ({ type: NOVO_ENQUETE });

export const inicioEnquetesSucesso = (enquetes) => ({
  type: INICIO_ENQUETES_SUCESSO,
  payload: enquetes,
});

export const salvaEnqueteLocal = (enquete, continuarNovo = false) => ({
  type: SALVA_ENQUETE_LOCAL,
  payload: { enquete, continuarNovo },
});


export const setarImagemEnquete = (imagem) => {

  return {
    type: SETAR_IMAGEM_ENQUETE,
    payload: { imagem }
  };
}

export const atualizaHorario = (e) => {
  var key = e.which || e.keyCode || e.charCode;
  var indexUnderline = e.target.name.indexOf("_");
  var indiceAtualizacao = parseInt(e.target.name.substring(indexUnderline + 1));
  var campo = e.target.name.replace(e.target.name.substring(indexUnderline), "");
  var valor = e.target.value;
  var removeDoisPontos = e.target.defaultValue.replace(e.target.value, '') === ':';

  if (!removeDoisPontos && valor.length === 2) {
    valor = valor + ":";
  }

  return {
    type: ATUALIZA_HORARIO,
    payload: { campoAtualizar: campo, indice: indiceAtualizacao, valor: valor }
  };
};

export const salvaEnqueteSucesso = (resultado) => ({
  type: SALVA_ENQUETE_SUCESSO,
  payload: resultado,
});

export const removeEnqueteLocal = (id) => ({
  type: REMOVE_ENQUETE_LOCAL,
  payload: id,
});

export const removeEnqueteSucesso = (resultado) => ({
  type: REMOVE_ENQUETE_SUCESSO,
  payload: resultado,
});

export const listaEnquetes = () => ({ type: LISTA_ENQUETES });

export const listaEnquetesSucesso = (enquetes) => ({
  type: LISTA_ENQUETES_SUCESSO,
  payload: enquetes,
});

export const buscaEnqueteEdicao = (idEnquete) => ({
  type: BUSCA_ENQUETE_EDICAO,
  payload: idEnquete,
});

export const buscaEnqueteEdicaoSucesso = (enquete) => ({
  type: BUSCA_ENQUETE_EDICAO_SUCESSO,
  payload: enquete,
});

export const abreDashboardEnquete = (idEnquete) => ({
  type: ABRE_DASHBOARD_ENQUETE,
  payload: idEnquete,
});

export const abreDashboardEnqueteSucesso = (enquete) => ({
  type: ABRE_DASHBOARD_ENQUETE_SUCESSO,
  payload: enquete,
});

export const fechaDashboardEnquete = () => ({
  type: FECHA_DASHBOARD_ENQUETE,
});

export const registraVotoEnquete = (voto) => ({
  type: REGISTRA_VOTO_ENQUETE,
  payload: voto,
});

export const registraVotoEnqueteSucesso = (mensagem) => ({
  type: REGISTRA_VOTO_ENQUETE_SUCESSO,
  payload: mensagem,
});

export const cancelaEdicaoEnquete = () => ({ type: CANCELA_EDICAO_ENQUETE });

export const limparFiltroEnquete = () => ({ type: LIMPAR_ENQUETE });

export const showEnquetesMessage = (message) => ({
  type: ENQUETES_SHOW_MESSAGE,
  payload: message,
});

export const hideEnquetesMessage = () => ({ type: ENQUETES_HIDE_MESSAGE });
